<template>
  <el-form-item>
    <el-card
      v-loading="loading"
      >
      <div slot="header">
        {{ $t('api.user.mfaQRCode')}}
      </div>
      <div v-if="uid">
        <el-image
          style="width: 256px; height: 256px"
          :src="url"
          >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <el-button
        type="warning"
        class="form-action-btn"
        @click="reset"
        >
        {{ $t('api.user.mfaQRCodeReset')}}
      </el-button>
    </el-card>
  </el-form-item>
</template>

<script>
import { reset } from '@/api/auth/mfa'

export default {
  name: 'mfa-qr-code',
  props: {
    uid: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      ts: new Date().getTime(),
      loading: false
    }
  },
  computed: {
    url () {
      if (this.uid && this.ts) {
        return process.env.BASE_API + '/user/admin/' + this.uid + '/mfa?t=' + this.ts
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    reset () {
      this.$confirm(
        this.$t('api.user.mfaQRCodeResetMsg'),
        this.$t('api.user.mfaQRCodeResetTitle'),
        {
          confirmButtonText: this.$t('api.confirmBtn'),
          cancelButtonText: this.$t('api.cancelBtn'),
          confirmButtonClass: 'el-button--danger',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.loading = true
        reset(this.uid).then(() => {
          this.ts = new Date().getTime()
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.loading = false
        })
      }).catch(err => {
        console.log(err)
      })
    }
  },
  watch: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .image-slot{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
  }
</style>
